import { Heading, SimpleGrid, Stack, Text, Box} from '@chakra-ui/react';
import { InformationIcon, VaultIcon, DataManagementIcon } from 'Components/Icons';
import React from 'react';
import { ILoopLandingPageLocalizationDocument } from 'Types/Interface/Sanity';


interface IPrivacySectionProps{
	loopLandingPageLocalization: ILoopLandingPageLocalizationDocument | null;
}


export const PrivacySection = ({loopLandingPageLocalization}:IPrivacySectionProps) => {
	const PrivacyContent = [
		{
			title: loopLandingPageLocalization?.informationTitle,
			subText: loopLandingPageLocalization?.informationDescription,
			icon:<InformationIcon/> 
		},
		{
			title : loopLandingPageLocalization?.controlTitle,
			subText: loopLandingPageLocalization?.controlDescription,
			icon: <DataManagementIcon/>
		},
		{
			title : loopLandingPageLocalization?.securityTitle,
			subText: loopLandingPageLocalization?.securityDescription,
			icon: <VaultIcon/>
		}
	];
	return(
		<Stack spacing={['30px','80px']} >
			<Stack spacing={'30px'}>
				<Heading textTransform={'uppercase'} fontSize={['30px','40px']} fontWeight={600}>{loopLandingPageLocalization?.privacyTitle}</Heading>
				<Text w={['','70%']} fontSize={['16px', '18px']} fontWeight={500} color={'#2B2B2B;'}>{loopLandingPageLocalization?.privacyDescription}</Text>
			</Stack>
			<SimpleGrid columns={[1,3]} spacing={'30px'} pb={['50px','100px']} >
				{
					PrivacyContent.map((item, index) => {
						return(
							<Stack	spacing={['20px','30px']} key={index}>
								<Box boxSize={['30px','50px']}>{item.icon}</Box>
								<Heading textTransform={'uppercase'} fontWeight={600} fontSize={['18px','20px']}>{item.title}</Heading>
								<Text fontSize={['16px','18px']} w={'100%'}>
									{item.subText}
								</Text>
							</Stack>
						);
					})
				}
			</SimpleGrid>
			{/* <Stack 
				justify={'center'} 
				align={'center'} 
				pos={'relative'}

			>
				<Image display={['none', 'block']} src={backdrop} w={'100%'} h={'450px'} />
				<Image display={['block', 'none']} src={backdropMobile} w={'100%'} h={'427px'} />
				<Stack pos={'absolute'} align={'center'} textAlign={'center'} spacing={'20px'} px={4} >
					<Heading fontSize={['24px','40px']} color={'white'}>Have a business and want to <br /> sell with Loop?</Heading>
					<Text fontSize={['16px','18px']} color={'white'}>Build strong, safe and meaningful connections with your customers!</Text>
					<Stack direction={['column','row']} spacing={'20px'}>
						<Button border={'1px solid #fff'} w={'150px'} h={'60px'} borderRadius={'5px'} bg={'white'} color={'darkCoral'}>Contact us</Button>
					</Stack>
				</Stack>
			</Stack> */}
		</Stack>
	);
};